module.exports = __webpack_public_path__ + "img/goodStyle-3.3e695e50.jpg";